<script >

export default {
  name: "PokerTypeMenu",
  components: {},
  props:{
    pokerType:0,
    pokerPoint:0,
    pokerDouble:0,
    pokerBet:0,
    isSeat:false,
    lang: '',
    Phone:false,
  },
  data()
  {
    return {

    }
  },
  methods: {

  }
}
</script>

<template>
  <div class="menu">
    <div class="wintype" v-if="pokerType == 0">
      {{pokerPoint + $t(`lang.str_card_point`)}}
    </div>
    <div class="wintype" v-if="pokerType == 1">
      {{$t(`lang.str_card_bj_5dragon`)}}
    </div>
    <div class="wintype" v-if="pokerType == 2">
      {{$t(`lang.str_card_bj_blackjack`)}}
    </div>
    <div class="wintype" v-if="pokerType == 3">
      {{$t(`lang.str_card_bj_bust`)}}
    </div>
    <div class="wintype" v-if="isSeat && pokerDouble">
      {{$t(`lang.str_card_bj_double`)}}
    </div>
    <div class="wintype" v-if="isSeat">
      {{$t(`lang.str_betd`)}} {{(pokerBet / 100).toFixed(2)}}
    </div>
  </div>
</template>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/joker/game2000/poker_type_menu.vue